/**
 * Client-side Excel parsing utilities
 */


/**
 * Detect facility column from column names
 * @param {Array} columnNames - Excel column names
 * @returns {string|null} Detected facility column name
 */
export function detectFacilityColumn(columnNames) {
  const facilityPatterns = [
    'facility',
    'facility name',
  ];

  for (const columnName of columnNames) {
    const normalizedName = columnName.toLowerCase().trim();
    
    for (const pattern of facilityPatterns) {
      if (normalizedName === pattern || normalizedName.includes(pattern)) {
        return columnName;
      }
    }
  }

  return null;
}

/**
 * Validate required fields are mapped
 * @param {Object} mappings - Column mappings
 * @param {string} type - Tag type
 * @returns {Object} Validation result
 */
export function validateRequiredMappings(mappings, type) {
  const requiredFields = {
    common: ['name'], // Tag number is always required
  };

  const errors = [];
  const warnings = [];

  // Check required common fields
  for (const field of requiredFields.common) {
    if (!Object.values(mappings).includes(field)) {
      errors.push(`Required field "${field}" is not mapped`);
    }
  }

  // Check type-specific required fields
  const typeFields = requiredFields[type.toLowerCase()] || [];
  for (const field of typeFields) {
    if (!Object.values(mappings).includes(field)) {
      errors.push(`Required field "${field}" for ${type} is not mapped`);
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
    warnings
  };
}